import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);
  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = new URLSearchParams(location.hash.slice(1));
    const sid = hash.get("session_id");
    if (!sid) { navigate("/admin/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sid },
          withCredentials: true,
        });
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { user: data.user }, replace: true });
      } catch (e) {
        navigate("/admin/login?error=" + encodeURIComponent(e?.response?.data?.detail || "auth_failed"), { replace: true });
      }
    })();
  }, [location, navigate]);
  return (
    <div className="pt-32 text-center">
      <Loader2 className="w-10 h-10 text-amber-600 mx-auto animate-spin" />
      <p className="mt-4 text-slate-600">Signing you in…</p>
    </div>
  );
}
